const splitLines = (simNumber) => {
    return simNumber
        .split(/\D/)
        .filter(element =>
            element.length > 0
        );
};

export default splitLines;